// @ts-nocheck
import Tabs from './components/Tabs';
import List from './components/List';
import Tab from './components/Tab';
import Body from './components/Body';
import Panel from './components/Panel';

Tabs.List = List;
Tabs.Tab = Tab;
Tabs.Body = Body;
Tabs.Panel = Panel;

export default Tabs;
